import { render, staticRenderFns } from "./MultipleCommentWithDescriptionCheckbox.vue?vue&type=template&id=3cb41262"
import script from "./MultipleCommentWithDescriptionCheckbox.vue?vue&type=script&lang=ts"
export * from "./MultipleCommentWithDescriptionCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports